import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth";
import { ErrorBoundary } from "./components/ErrorBoundary";
import "./styles.css";

const mount = document.getElementById("root");
if (!mount) throw new Error("admin: missing #root mount");

createRoot(mount).render(
  <StrictMode>
    <BrowserRouter>
      {/* Outside AuthProvider on purpose: a throw in the auth bootstrap is
          exactly the kind that used to blank the page with no clue why. Inside
          the router so the fallback can still be styled and read. */}
      <ErrorBoundary label="Quiz Admin">
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>,
);
